<template>
  <v-card
    class="status-card py-3 px-6 text-center"
    outlined
    elevation="1"
    style="border-radius: 16px;"
  >
    <!-- 標題 -->
    <div class="subtitle-2 text--secondary mb-2">
      {{ title }}
    </div>

    <!-- 大數字 -->
    <div class="text-h4 font-weight-bold mb-2">
      {{ value }}
    </div>

    <!-- 說明文字 -->
    <div class="caption text--secondary">
      {{ description }}
      <slot />
    </div>
  </v-card>
</template>

<script>
export default {
  name: "SimpleStatCard",
  props: {
    title: String,
    value: [String, Number],
    description: String,
  },
};
</script>

<style scoped>
.status-card {
  width: max-content;
}
</style>
